import styled, { css } from "styled-components";

export const CheckboxGroupContainer = styled.div`
  width: 100%;
  margin-bottom: 1.5rem;
`;

export const CheckboxGroupTitle = styled.h2`
  font-size: 18px;
  font-weight: 500;
  color: #181d27;
  margin: 2rem 0 0.75rem 0;
  font-family: "Geist", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px; /* 150% */
`;

export const CheckboxGroupSubtitle = styled.p`
  font-size: 14px;
  color: #717184;
  margin: 0 0 2rem 0;
`;

export const CheckboxOptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 13px;
`;

export const CheckboxOption = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px 16px;
  border-radius: 9999px;
  border: 1px solid #e9eaeb;
  background: #fafafa;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: border-color 0.2s ease, background-color 0.2s ease,
    color 0.2s ease;

  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #414651;
  text-align: center;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
    `}
  &:hover {
    border-color: #2258f1;
    background: rgba(34, 88, 241, 0.05);
    color: #2258f1;
  }
  ${({ isSelected }) =>
    isSelected &&
    css`
      border-color: #2258f1;
      color: #2258f1;
      background: rgba(34, 88, 241, 0.08); /* subtle tint */
    `}
`;

export const CheckboxInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

export const CheckboxLabel = styled.label`
  font-size: 14px;
  cursor: pointer;
  flex: 1;
  color: ${({ isSelected }) => (isSelected ? "#2258f1" : "#414651")};
`;
